export interface UserAvatarProps {
    userImage?: any;
}

export function UserAvatar({ userImage }: UserAvatarProps) {
    return (
        <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center overflow-hidden">
            {userImage ? (
                <img src={userImage} alt="User avatar" className="w-full h-full object-cover" />
            ) : (
                <img src="/assets/images/monica.png" alt="Monica avatar" className="w-full h-full object-cover" />
            )}
        </div>
    );
}
